import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { PropsOf } from 'types/jsx';

type PropTypes = PropsOf<FormattedMessage> & { unsafeReportId: string };

// Similar to `FormattedMessage` but it renders nothing
// instead of blowing up the application when there is no message id.
// The prop `unsafeReportId` is required when using component,
// as we log an error to the console when there is no id.
const UnsafeFormattedMessage = (props: PropTypes): JSX.Element | null => {
  if (!props.id) {
    // eslint-disable-next-line no-console
    console.error(`No id was provided for the component at ${props.unsafeReportId}`);
    return null;
  }

  return <FormattedMessage {...props} />;
};

export default UnsafeFormattedMessage;
